export default "__VITE_ASSET__Dy4u88qh__"